import styled from 'styled-components';
import { lighten } from 'polished';

export const NavbarWrapper = styled.nav`
    display: flex;
    justify-content: space-around;
    align-items: center;
    justify-items: center;
    max-width: 100%;
    height: 100px;

    figure {
        img {
            max-width: 140px;
        }

        /**
        * Esconde o icone de abrir o menu   
        */
        .dropdown {
            display: none;
        }
    }

    ul {
        display: flex;
        
        li {
            font-size: 16px;
            margin: 0 10px;
            font-weight: 600;
            transition: 0.3s;

            &:nth-child(6) {
                a {
                    padding: 10px 20px 10px 20px;
                    background: var(--orange);
                    border-radius: 50px;
                    border: 2.5px solid transparent;
                    color:var(--white);   
                    transition: 0.3s;
                    &:hover {
                        background: transparent;
                        color:var(--blue);   
                        border: 2.5px solid var(--orange) ;
                    }  
                }
                        
            }
            a {
                color: var(--blue);
                text-decoration: none;
                transition: 0.3s;
                &:hover { 
                    color: ${lighten(0.3, '#38418e')};
                }
            }
        }
    }

    /**
    * Esconde a navbar lateral mobile
    */
    #navbar {
        display: none;
    }

    @media (max-width: 800px) {
        display: flex;
        /* justify-content: space-around; */
        align-items: center;
        justify-items: normal;
        width: 100%;
        height: 100px;

        figure {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 auto;
            width: 100%;

            img {
                
                padding-left: 40px;
                /* width: 140px; */
            }

            .dropdown {
                width: 50%;
                cursor: pointer;
                display: inline-block;
                transition: 0.3s;
            }

        }
        
        ul {
            li {
                display: none;
            }
        } 

   
        #navbar {
            position: fixed;
            width: 0;
            right: 0;
            top: 0;
            background: var(--white);
            display: block;
            height: 100vh;
            border-left: 2px solid transparent;
            transition: cubic-bezier(0.075, 0.82, 0.565, 1)0.7s;
            box-shadow: 1px 1px 0.1px 0.1px rgba(0, 0, 0, 0.3);
            li {
                
                display:block;
                padding-left: 35px;
                font-size: 16px;
                margin: 20px 0px;
                font-weight: 600;
                transition: 0.3s;

                .close {
                    display: block;
                }
                &:nth-child(6) {
                    a {
                        padding: 0;
                        background: none;
                        border-radius: 0;
                        border: 0 none transparent ;
                        color:var(--blue);   
                        transition: 0.3s;
                        
                        &:hover {
                            color: ${lighten(0.3, '#38418e')};
                            background: none;
                            color: none;   
                            border: 0 none transparent ;
                        }  
                    }
                }
            }
        } 
    }
`;